var _polygon, _line, _line2, _line3, _line4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#00AFEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32,8 6,24 58,24"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 24,
    x2: 14,
    y2: 48
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 24,
    x2: 26,
    y2: 48
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 24,
    x2: 38,
    y2: 48
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 24,
    x2: 50,
    y2: 48
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 48,
    width: 52,
    height: 6,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/Government.ce95ba17e7db91963dc2a36faed99fa4.svg";
export { ForwardRef as ReactComponent };